import { t, waitForInitialization } from '../../essentials/i18n';

async function translate(key: string): Promise<string>;
async function translate(key: string[]): Promise<string[]>;
async function translate(key: string | string[]): Promise<string | string[]> {
  await waitForInitialization();

  if (Array.isArray(key)) {
    return key.map((k) => t(k));
  }

  return t(key);
}

export { translate };
